<template>	
	<div>
        <div class="row">
            <div class="col-xs-6 col-lg-6">
                <h1 class="title-label">:(</h1>
            </div>
            <div class="col-xs-6 col-lg-6">
                <h1 class="title">404</h1>
                <h2 class="subtitle">PÁGINA NÃO ENCONTRADA</h2>
                <p>Desculpe, não foi possível encontrar a página.</p>
                <p>A página pode não existir ou não ser possível o seu acesso no momento.</p>
                <p>Tente novamente!</p>
                <button class="btn btn-black" @click="backToHome"><i class="fas fa-flip-horizontal fa-share"></i> Voltar para o início</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "PageNotFound",

	data: function() {
		return {
			loading: false,
		}
	},

    methods: {
        backToHome: function() {
            this.$router.push({ name: 'Home'});
        },
    },
}
</script>

<style scoped>
.title-label {
    font-weight: bolder;
    font-size: 200px;
    text-align: right;
    margin-right: 50px;
}

.title {
    font-weight: bolder;
    font-size: 150px;
    margin-block-end: 0px;
}

.subtitle {
    margin-block-start: 0px;
}

.btn {
	font-size: 16px;
	padding: 10px;
	text-decoration: none;
	border: none;
}

.btn-black {
    background: #222;
	color: #fff;
}
</style>